import * as yup from 'yup';
import { API as departments } from '../../departments/api';
import { PriorityOptions } from './Data.conf';
import { API as suppliers } from '../../suppliers/api';
import { API as marina } from '../../marina/api';
import { API as categories } from '../../categories/api';
import { API as subCategories } from '../../subCategories/api';

export const FilterConf = {
  schema: yup.object({
    id_departments: yup.array().nullable(),
    priority: yup.array().nullable(),
    id_marina: yup.array().nullable(),
    company_name: yup.array().nullable(),
    id_category: yup.array().nullable(),
    id_sub_category: yup.array().nullable(),
  }),
  initialState: {
    value: {
      id_departments: [],
      company_name: [],
      priority: null,
      id_marina: [],
    },
  },
  fields: [
    {
      id: 'id_departments',
      name: 'id_departments',
      type: 'async_autocomplete_multiple',
      label: 'Department',
      api: departments.suppliersActiveDepartments,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'company_name',
      name: 'company_name',
      type: 'async_autocomplete_multiple',
      label: 'Suppliers',
      api: suppliers.select,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'id_locations',
      name: 'id_locations',
      type: 'async_autocomplete_multiple',
      label: 'Locations',
      api: marina.select,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'id_category',
      name: 'id_category',
      type: 'async_autocomplete_multiple',
      label: 'Category',
      api: categories.select,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'id_sub_category',
      name: 'id_sub_category',
      type: 'async_autocomplete_multiple',
      label: 'Sub Category',
      api: subCategories.select,
      required: false,
      xs: 12,
      sm: 6,
      md: 3,
    },
    {
      id: 'priority',
      name: 'priority',
      type: 'autocomplete_multiple',
      label: 'Priority',
      options: PriorityOptions,
      xs: 12,
      sm: 6,
      md: 3,
    },
  ],
  query: {
    keys: [
      {
        key: 'id_departments.id',
        value: 'id_departments.id',
        operator: '$eq',
      },
      {
        key: 'priority',
        value: 'priority.label',
        operator: '$eq',
      },
      {
        key: 'id',
        value: 'company_name.id',
        operator: '$eq',
      },
      {
        key: 'id_locations.id',
        value: 'id_locations.id',
        operator: '$eq',
      },
      {
        key: 'id_category.id',
        value: 'id_category.id',
        operator: '$eq',
      },
      {
        key: 'id_sub_category.id',
        value: 'id_sub_category.id',
        operator: '$eq',
      },
    ],
  },
};
